var path = '/userProfileButton/environment/environment.tpl.html';
var html = "<div class=\"env\"\n     ng-if=\"$ctrl.showEnvironment\">\n    {{ ::$ctrl.environment }}\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;